import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../redux/store";
import { PersistPartial } from "redux-persist/es/persistReducer";
import { AuthState } from "../redux/slices/authSlice";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { token, isAuthenticated } = useSelector((state: RootState) => state.auth as AuthState & PersistPartial );

  if (!isAuthenticated || !token) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
